if (!customElements.get('marquee-component')) {
  class MarqueeComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.marquee__track');
      this.group = this.querySelector('.marquee__group');
      this.groups = [...this.querySelectorAll('.marquee__group')];

      if (!this.track || !this.group) return;

      this.updateDuration = this.updateDuration.bind(this);
      this.resizeObserver = new ResizeObserver(this.updateDuration);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.group);
      requestAnimationFrame(this.updateDuration);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateDuration() {
      this.ensureCoverage();

      const groupWidth = this.group.getBoundingClientRect().width;
      const speed = Math.max(Number(this.dataset.speed) || 80, 1);

      if (groupWidth > 0) {
        this.track.style.setProperty('--marquee-duration', `${groupWidth / speed}s`);
      }
    }

    ensureCoverage() {
      const minimumWidth = this.getBoundingClientRect().width * 1.1;

      this.groups.forEach((group) => {
        const template = group.querySelector('.marquee__set[aria-hidden="true"]');
        if (!template || !template.querySelector('.marquee__item')) return;

        let copiesAdded = 0;
        while (group.getBoundingClientRect().width < minimumWidth && copiesAdded < 30) {
          const copy = template.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          group.appendChild(copy);
          copiesAdded += 1;
        }
      });
    }
  }

  customElements.define('marquee-component', MarqueeComponent);
}
